<template>
  <div class='AdmSearch'>
    <search-icon width="20px" height="25px"/>
    <input type="text" :placeholder="place" @input="run">
  </div>
</template>

<script>
import SearchIcon from '../icons/SearchIcon'
export default {
  name: 'AdmSearch',
  components: { SearchIcon },
  props: {
    place: {
      type: String,
      default: 'Pesquisar'
    }
  },
  data () {
    return {
      timeout: null
    }
  },
  methods: {
    run (e) {
      if(this.timeout !== null) {
        clearTimeout(this.timeout)
      }
      this.timeout = setTimeout(() => {
        this.$emit('run', e.target.value)
      }, 1500)
    }
  }
}
</script>

<style scoped>
.AdmSearch {
  display: flex;
  align-items: center;
  border: thin solid #CCCCCC;
  border-radius: 5px;
  overflow: hidden;
  padding: 5px;
}
input {
  border: 0;
  padding: 5px;
  font-size: 16px;
}
input:focus {
  outline: none;
}
</style>
